import { render, staticRenderFns } from "./Video_release.vue?vue&type=template&id=45e157df&style=true"
import script from "./Video_release.vue?vue&type=script&lang=js"
export * from "./Video_release.vue?vue&type=script&lang=js"
import style0 from "./Video_release.vue?vue&type=style&index=0&id=45e157df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports